import React from 'react';
import { useSelector } from 'react-redux';

import Icon from 'dpl/common/components/Icon';
import { FILTER_LOCATION_NAME } from 'dpl/constants/query_params';

export default function PageHeroLocation() {
  const locationTitle = useSelector(
    ({ server, queryParams }) =>
      queryParams[FILTER_LOCATION_NAME] || server.locationTitle
  );

  if (!locationTitle) {
    return null;
  }

  return (
    <span className="inline-flex items-center gap-8 lh-title mt4 o-70">
      <Icon name="fetch-location" className="branch" />
      <span className="lg:font-serif fw-medium-l font-16 lg:font-20 branch-dark tl">
        Near {locationTitle}
      </span>
    </span>
  );
}
